import { Record, Map } from "immutable"

import {
    toUI as defaultToUI,
    normaliseModel,
    hydrateModel,
    updateChangeModel,
    updateCreateModel
} from "../model-utils"
import moment from "moment"

export const UserModel = new Record({
    id: "",
    bio: "",
    communities_followed: [],
    communities_member_of: [],
    emails: [],
    email: "",
    first_name: "",
    full_name: "",
    funky_id: "",
    imagePreviewURL: undefined,
    languages: [],
    last_name: "",
    last_updated: moment(),
    organisation: "",
    permission_groups: [],
    photo_url: "",
    primary_email: "",
    primary_organisation: "",
    primary_position: "",
    status: "",
    topics_followed: []
})

export function UserCreateModel() {
    return Map({
        first_name: "",
        last_name: "",
        full_name: "",
        status: "Inactive"
    })
}

const dateFields = ["last_updated"]
const tagFields = []
export const normalisingFields = []

const addRemoveFields = [
    "communities_followed",
    "communities_member_of",
    "permission_groups",
    "topics_followed",
    "emails"
]

export const normalise = user => normaliseModel(user, ...normalisingFields)
export const hydrate = (user, ...entityStates) =>
    hydrateModel(user, normalisingFields, entityStates)

export const updateUserChangeModel = (name, value, changeModel, workingModel) =>
    updateChangeModel(name, value, changeModel, workingModel, addRemoveFields)

export const updateUserCreateModel = (name, value, createModel, workingModel) =>
    updateCreateModel(name, value, createModel, workingModel, addRemoveFields)

export const toUI = user => defaultToUI(user, dateFields, tagFields)
